import criteriaSymbols from "../symbols/criterias";

const initialState = {
  data: { Brands: [], Merchants: [] },
  loading: false,
  error: false,
};

export default function CriteriaSymbolsReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case criteriaSymbols.GET_CRITERIAS:
      return { ...state, loading: true, error: false };
    case criteriaSymbols.GET_CRITERIAS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: false,
      };
    case criteriaSymbols.GET_CRITERIAS_FAILURE:
      return {
        ...state,
        data: { Brands: [], Merchants: [] },
        loading: false,
        error: true,
      };
    case criteriaSymbols.CLEAR_GET_CRITERIAS:
      return {
        ...state,
        data: { Brands: [], Merchants: [] },
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
